import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as a}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const i=a`
<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    static
>
    <mask
        id="mask0_5455_1355"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
    >
        <path
            d="M24 12.0937C24 18.6694 18.5756 24 12 24C5.42434 24 0 18.6694 0 12.0937C0 5.46632 5.37258 0 12 0C18.6274 0 24 5.46632 24 12.0937Z"
            fill="white"
        />
    </mask>
    <g mask="url(#mask0_5455_1355)">
        <path
            d="M20.1664 1.08606e-05H3.83392C1.71434 1.08606e-05 0 1.71435 0 3.83362V20.1352C0 22.2857 1.71434 24 3.83392 24H20.1351C22.2859 24 24.0002 22.2857 24.0002 20.1661V19.9169C24.0002 19.9169 17.7977 17.33 14.6494 15.8027C12.5301 18.3584 9.81827 19.9481 7.01309 19.9481C2.24444 19.9481 0.623442 15.7715 2.86761 13.0287C3.36649 12.4364 4.20789 11.8442 5.48579 11.5323C7.51168 11.0337 10.7533 11.8442 13.7768 12.8414C14.3066 11.8442 14.7742 10.7221 15.117 9.53761H5.76638V8.60255H10.5975V6.88822H4.80017V5.95315H10.6287V3.52202C10.6287 3.52202 10.6287 3.11679 11.0339 3.11679H13.4027V5.95315H19.1689V6.88822H13.4027V8.60255H18.1093C17.6728 10.4415 16.9871 12.1558 16.1145 13.6519C17.5482 14.1817 18.8261 14.6494 19.7924 14.9922C23.221 16.1455 24.0002 16.2079 24.0002 16.2079V3.83361C24.0002 1.71434 22.2859 0 20.1664 0V1.08606e-05Z"
            fill="#00A0E9"
        />
        <path
            d="M3.37327 13.5121C1.6584 14.9413 2.68733 17.5709 6.1458 17.5709C8.14643 17.5709 10.1473 16.3418 11.7191 14.3696C9.48976 13.312 7.57467 12.569 5.54542 12.7689C4.97396 12.7975 3.945 13.0263 3.37327 13.5121Z"
            fill="#00A0E9"
        />
    </g>
</svg>
`,e=t("alipay",i),m=t("alipay_direct",i);export{e as Alipay,m as AlipayDirect};
